export interface PayeeDetailModel {}
